/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelAgain = new Class({
    Extends:PanelYesNo,
    attach: function(){
        var Options = this.element.getElements('.yesno--option');
            Options.each(function(oOption,i){
                oOption.addEvents({
                    click: function(){
                        Options.removeClass('selected--option');
                        oOption.addClass('selected--option');

                        var value = oOption.get('data-option-value');
                        var next = this.data.next[value];

                        if(next == 'restart'){
                            this.againCallback();
                            this.element.addClass('isAnswered');
                            return;
                        }
                        this.after(value);
                    }.bind(this)
                });
            }.bind(this));
    }
});